export const THEME_CONFIG = {
  locale: 'en',
  topNavColor: '#004D4D',
  headerNavColor: '',
  currentTheme: 'dark',
  direction: 'ltr',
  navCollapsed: false,
  parcelMode: false,
};
